// extracted by mini-css-extract-plugin
module.exports = {"CollectionItemContainer":"CollectionItemContainer___2f-x3","Title":"Title___1GIqj","loading":"loading___2n-TR"};